import { AppIcon } from '@shared-ui/components/ui/app-icon'
import { GText } from '@shared-ui/components/ui/text'
import { useBalanceHider } from '@shared-ui/hooks/ui/use-balance-hider'
import type { ReactNode } from 'react'
import { Pressable, type StyleProp, View, type ViewStyle } from 'react-native'
import { useCreateStyles } from './styles'
import { AppTransactionRowState } from './types'

export type AppTransactionRowProps = {
  title: string
  subtitle: string
  amount: string
  secondaryAmount?: string
  avatar: ReactNode
  state?: AppTransactionRowState
  isIncome?: boolean
  onPress?: () => void
  style?: StyleProp<ViewStyle>
  testID?: string
}

export function AppTransactionRow({
  title,
  subtitle,
  amount,
  secondaryAmount,
  avatar,
  state = AppTransactionRowState.Success,
  isIncome = false,
  onPress,
  style,
  testID,
}: AppTransactionRowProps) {
  const styles = useCreateStyles()
  const { isBalanceShow } = useBalanceHider()
  const isCancelled = state === AppTransactionRowState.Cancelled
  const hasSecondaryAmount = Boolean(secondaryAmount && secondaryAmount !== amount)
  return (
    <Pressable accessibilityRole="button" onPress={onPress} testID={testID} style={[styles.root, style]}>
      {avatar}
      <View style={[styles.content, isCancelled && styles.cancelled]}>
        <GText variant="caption-14-medium" numberOfLines={1} isSecondary={isCancelled}>
          {title}
        </GText>
        <GText variant="caption-13-regular" isSecondary>
          {subtitle}
        </GText>
      </View>
      <View style={styles.amounts}>
        <View style={styles.amountRow}>
          <GText
            variant="caption-14-medium"
            isSecondary={state !== AppTransactionRowState.Success}
            isSuccess={isIncome && state === AppTransactionRowState.Success}
            style={isCancelled ? styles.strike : undefined}
          >
            {isBalanceShow ? amount : '••••'}
          </GText>
          {state === AppTransactionRowState.Pending && <AppIcon icon="clock" size={20} isSecondary />}
        </View>
        {hasSecondaryAmount && (
          <GText variant="caption-13-regular" isSecondary style={isCancelled ? styles.strike : undefined}>
            {isBalanceShow ? secondaryAmount : '••••'}
          </GText>
        )}
      </View>
    </Pressable>
  )
}
